<template>
	<div>
		<vheader :insti="insti"/>

		<div class="line">
			<el-button class="link" @click="dialogVisible=true">添加</el-button>
		</div>
		<el-table :data="tableData" style="width: 80%;margin: 20px auto 0;" border height="calc(100vh - 300px) ">
			<el-table-column type="index" label="序号" width="150" align="center"></el-table-column>
			<el-table-column prop="name" label="用户名" align="center"></el-table-column>
			<el-table-column prop="passport" label="账号" align="center"></el-table-column>
			<el-table-column prop="mobileNo" label="手机号" align="center"></el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button class="link" v-if="scope.row.status==0" @click="recover(scope.row.id)">恢复</el-button>
					<el-button class="link" v-if="scope.row.status==1" @click="daleteUser(scope.row.id)">冻结</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog title="添加账号" align="center" :visible.sync="dialogVisible" width="30%" >
			 <el-form :model="form" :rules="rules" ref="ruleForm" label-width="80px">
				  <el-form-item label="用户名:" prop="name">
					   <el-input v-model="form.name"></el-input>
				  </el-form-item>
				  <el-form-item label="账号:" prop="passport">
				  		<el-input v-model="form.passport"></el-input>
				  </el-form-item>
				  <el-form-item label="密码:" prop="password">
				  		<el-input v-model="form.password"></el-input>
				  </el-form-item>
				  <el-form-item label="手机号:" prop="mobileNo">
				  		<el-input v-model="form.mobileNo"></el-input>
				  </el-form-item>

			 </el-form>
			  <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="toSureAdd()">确 定</el-button>
			  </span>
		</el-dialog>
	</div>
</template>

<script>
import vheader from '@/components/header'
import { subUserList,addSubUser,freezeSubUser } from '@/views/axios/api.js'
export default {
	data() {
		return {
			insti:this.$route.params.insti || JSON.parse(window.localStorage.getItem("insti")),
			dialogVisible:false,
			timer: null,
			tableData: [],
			allpage: 10,
			tinkw: '',
			options:[],
			channelId:'',
			form:{
                name:'',
				passport:'',
				password:'',
				mobileNo:'',

			},
			typeList:["个人发票","企业发票（普通）","企业发票（专票）"],
			invoiceId:'',
			rules:{
				name:[
                   { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
				passport:[
				   { required: true, message: '请输入账号', trigger: 'blur' }
				],
				password:[
				   { required: true, message: '请输入密码', trigger: 'blur' }
				],
				mobileNo:[
				   { required: true, message: '请输入手机号', trigger: 'blur' }
				],
			}
		};
	},
	components:{
		vheader
	},
	methods: {

		setTime(str) {
			return common.time(str);
		},

		getData() {
			var data={
				start:0,
				count:100,
				token:JSON.parse(window.localStorage.getItem("data")).data,

			}
			subUserList(data)
			.then( res =>{
				this.tableData=res.data.obj
			})
			.catch(err =>{
				console.log(err)
			})
		},
		toSureAdd(){
			var that = this;
			 this.$refs['ruleForm'].validate((valid) => {
				  if (valid) {
				    that.form.token=JSON.parse(window.localStorage.getItem("data")).data,
					addSubUser(that.form)
					.then( res =>{
					   if(res.data.code==0){
						     this.$message({
							  message: '账号添加成功',
							  type: 'success'
							});
							that.form.name='';
							that.form.passport='';
							that.form.password='';
							that.form.mobileNo='';
							that.dialogVisible=false;
							that.getData()
					   }
					})
					.catch( err=>{
						console.log(err)
					})
				  } else {

					return false;
				  }
				});

		},
		daleteUser(num){
			var that = this;
			 this.$confirm('确认冻结此用户?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
					var data={
						id:num,
						status:0,
						token:JSON.parse(window.localStorage.getItem("data")).data,
					}
				   freezeSubUser(data)
				   .then( res =>{
					   if(res.data.code==0){
						  this.$message({
						    message: '冻结成功',
						    type: 'success'
						  });
						  that.getData()
					   }else if(res.data.code==102001){
						  this.$message({
						    message: '当前登录用户没有权限',
						    type: 'warn'
						  });
						  that.getData()
					   }

				   })
				   .catch( err=>{
					   console.log(err)
				   })

				}).catch(() => {
				  this.$message({
					type: 'info',
					message: '已取消冻结'
				  });
			    });
		},
		recover(num){
			var that = this;
			 this.$confirm('确认恢复此用户?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
					var data={
						id:num,
						status:1
					}
				   freezeSubUser(data)
				   .then( res =>{
					   if(res.data.code==0){
						  this.$message({
						    message: '用户已恢复',
						    type: 'success'
						  });
						  that.getData()
					   }else if(res.data.code==102001){
						  this.$message({
						    message: '当前登录用户没有权限',
						    type: 'warn'
						  });
						  that.getData()
					   }

				   })
				   .catch( err=>{
					   console.log(err)
				   })

				}).catch(() => {
				  this.$message({
					type: 'info',
					message: '已取消恢复'
				  });
			    });
		},



	},
	mounted() {
		this.getData();
	}

};
</script>

<style scoped="scoped">
.search {
	overflow: hidden;
	margin-top: 20px;
}

.search .block {
	float: left;
	margin-right: 10px;
}

.sss {
	width: 180px;
}
.link{
	color: #00ABFA;
	border: none;
}
.line{
	text-align: right;
	width: 80%;
	margin: 30px auto;
}
</style>





// WEBPACK FOOTER //
// src/views/phone/phone.vue